<template>
  <v-card v-if="project">
    <v-card-title>
      <v-flex xs6>
        <v-avatar size=48>
          <img :src="logoThumbUrl" alt="Avatar" v-if="logoThumbUrl">
          <v-icon color="primary" large v-else>ballot</v-icon>
        </v-avatar>
        <span class="subheading pl-2">
          {{project.attributes.name}}
        </span>
      </v-flex>
    </v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        lazy-validation
        >
        <v-layout row wrap>
          <v-flex xs12 class="pr-2">
            <v-alert value="true" type="info" class="mt-3 mb-3" >
              One seat grants one user access for one month.
              <br>
              You currently have {{ seatsUsed }} active users and {{ seatsAvailable }} spare seats.
            </v-alert>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs3>
            <v-select
              v-model="wantedMonths"
              :items="[{value: '1', description: '1 month'}, {value: '2', description: '2 months'}, {value: '3', description: '3 months'}, {value: '6', description: '6 months'}, {value: '12', description: '12 months'}]"
              prepend-icon="counter"
              item-text="description"
              item-value="value"
              label="Extend duration to"
            ></v-select>
          </v-flex>

          <v-flex xs2 text-xs-center mt-3 h3>
            <h3 class="grey--text">
              or
            </h3>
          </v-flex>

          <v-flex xs3>
            <v-text-field
              name="seats"
              label="Number of seats"
              prepend-icon=" "
              v-model="wantedSeats"
              mask="###"
              @input="clearDuration()"
            ></v-text-field>
          </v-flex>

          <v-flex xs4 text-xs-center mt-3 h3>
            <h3 class="grey--text">
              for <span class="pl-3">{{ wantedSeats * 20.00 |toCurrencyWithCents}}</span>
            </h3>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-alert value="true" type="success" class="mt-3" v-if="plannedDuration >= 3" >
              You will have enough seats for current users to access the system for {{ parseInt(plannedDuration) }} more months.
            </v-alert>

            <v-alert value="true" type="warning" class="mt-3" v-else>
              Some users will not have access soon, we recommend you get at least {{ recommendedSeats }} more seat(s).
            </v-alert>

            <v-alert :value="errorText.length > 0" type="error" class="mt-3">
              {{ errorText }}
            </v-alert>
          </v-flex>
        </v-layout>

      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat href="/jargon/policy" target="jargon">Policies</v-btn>|
      <v-btn flat href="/jargon/pricing" target="jargon">Pricing</v-btn>|
      <v-btn flat href="/jargon/contact" target="jargon">Contact us</v-btn>|
      <v-btn flat color="primary" @click="done()">Never mind</v-btn>
      <v-btn color="success" :disabled="wantedSeats < 1" @click="purchase()">Buy seats now</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'
  import permissions from '@/utilities/permissions'

  import purchaseService from '@/services/purchase'

  export default {
    name: 'purchase-seats',

    props: ['project'],

    data () {
      return {
        auth: authentication,
        permit: permissions,
        localProject: {},
        wantedMonths: 1,
        wantedSeats: 1,
        busy: false,
        errorText: '',
        rules: {
          required: value => !!value || 'Required'
        }
      }
    },

    components: {
    },

    watch: {
      wantedMonths: {
        handler (val) {
          if (val !== null) {
            this.wantedSeats = Math.max((parseInt(val) * this.seatsUsed) - this.seatsAvailable, 0)
          }
        }
      },

      // the parent object might reload the project, so we should check for that
      // typically happens when a purchase is checked, and seats are added to the project
      project: {
        handler (val) {
          if (this.localProject) {
            this.localProject.seats = Object.assign({}, val.attributes.seats)
          }
        }
      }
    },

    computed: {
      logoThumbUrl () {
        if (this.project && this.project.links && this.project.links.logo_thumb_uri) {
          return (process.env.API_URL + this.project.links.logo_thumb_uri)
        }
        return null
      },

      seatsAvailable () {
        if (this.localProject && this.localProject.seats) {
          return parseInt(this.localProject.seats.available)
        }
        return 0
      },

      seatsUsed () {
        if (this.localProject && this.localProject.seats) {
          return parseInt(this.localProject.seats.used)
        }
        return 0
      },

      currentDuration () {
        return (this.seatsAvailable / this.seatsUsed)
      },

      recommendedSeats () {
        return (this.seatsUsed * 3) - this.seatsAvailable
      },

      plannedDuration () {
        return (this.seatsAvailable + parseInt(this.wantedSeats)) / this.seatsUsed
      }
    },

    mounted () {
      this.localProject = Object.assign({}, this.project.attributes)
    },

    methods: {

      clearDuration () {
        this.wantedMonths = null
      },

      done () {
        // NOTE: roll back any changes we made (project is passed in by reference)
        this.localProject = Object.assign({}, this.project.attributes)
        EventBus.$emit('project-purchase')
      },

      // NOTE: we dont want to save the updated logos until the users clicks save, so we process
      // those on a second pass once the form saved.
      purchase () {
        purchaseService.create(
          (data) => {
            this.errorText = ''
            console.log(data.attributes)
            window.open(data.attributes.eway_transaction.shared_payment_url, '_eway')
            EventBus.$emit('project-purchase', data)
          },
          (err) => {
            console.log(err)
            this.errorText = `A problem occurrred while trying to redirect you the payment site (${err.response.data.errors}).`
          },
          this.project.id,
          {seats: this.wantedSeats}
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-expansion-panel-setting {
    background-color: #0155a8 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/purchase/_new.vue